import { Logout } from '@mui/icons-material';
import { Icon, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import { useMenu } from 'shared/hooks';

interface UserMenuProps {
  logout(): void;
}
const HEADER_MENU_BUTTON = 'header-menu-button';
const HEADER_MENU_NAME = 'header-menu';

export function UserMenu({ logout }: UserMenuProps) {
  const [anchorEl, openMenu, closeMenu, open] = useMenu();

  return (
    <>
      <Menu
        id={HEADER_MENU_NAME}
        anchorEl={anchorEl}
        open={open}
        onClose={closeMenu}
        MenuListProps={{
          'aria-labelledby': HEADER_MENU_BUTTON,
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={logout}>
          <ListItemIcon>
            <Logout />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </Menu>
      <Tooltip title='Account'>
        <IconButton onClick={openMenu}>
          <Icon sx={{ color: 'common.white' }}>account_circle</Icon>
        </IconButton>
      </Tooltip>
    </>
  );
}
